export default __webpack_public_path__ + "static/media/placeholder.d5f5833f.png";